import { SequenceNode, SequenceNodeType } from "@/@types/flows/sequences";
// import { UpdateNodeDto } from "@/@types/flows/sequences/dto";
import { SequenceNodeFactory } from "@/app/flows/sequences/utils/NodeFactory";
import { SequenceType } from "@/app/flows/sequences/utils/enums";
import httpManager from "@/app/shared/utils/httpManager";
import { toRaw } from "vue";

// const testNodes: SequenceNode[] = [
//   {
//     id: 1,
//     action: SequenceNodeAction.Finish,
//     type: SequenceNodeType.TimeInterval,
//     child: [],
//     node: null,
//     sequence: 1,
//     waiting_time: "",
//   },
// ];
// const testNodes: SequenceNode[] = [];

class SequenceNodeService {
  private getBaseUrl = (sequenceId?: number) =>
    sequenceId ? `/sequences/${sequenceId}/nodes` : `/sequences/nodes`;

  async getNodes(sequenceId: number): Promise<SequenceNode[]> {
    const url = `${this.getBaseUrl(sequenceId)}/`;

    const response = await httpManager.get(url);

    return response.data;
  }

  async create(sequenceId: number, nodeType: SequenceNodeType, sequenceType: SequenceType | undefined, order?: number) {
    const url = `${this.getBaseUrl(sequenceId)}/`;
    const createPromises = [];

    if (nodeType === SequenceNodeType.AutomaticCall) {
      const newNode = SequenceNodeFactory.create(SequenceNodeType.AutomaticCall);
      newNode.node_order = order || 1;
      createPromises.push(httpManager.post(url, newNode));
    }

    if (nodeType === SequenceNodeType.TimeInterval) {
      if (sequenceType == SequenceType.AutomaticProgressive) {
        const newTimeIntervalNode = SequenceNodeFactory.create(SequenceNodeType.TimeInterval, sequenceType);
        const newAutomaticCallNode = SequenceNodeFactory.create(SequenceNodeType.AutomaticCall);

        newAutomaticCallNode.node_order = newTimeIntervalNode.node_order + 1;

        createPromises.push(
          httpManager.post(url, newTimeIntervalNode),
          httpManager.post(url, newAutomaticCallNode)
        );
      } else {
        const newTimeIntervalNode = SequenceNodeFactory.create(SequenceNodeType.TimeInterval, sequenceType);
        newTimeIntervalNode.node_order = order || 1;
        createPromises.push(
          httpManager.post(url, newTimeIntervalNode)
        );
      }
    }

    if (
      nodeType === SequenceNodeType.Whatsapp ||
      nodeType === SequenceNodeType.Sms ||
      nodeType === SequenceNodeType.Email
    ) {
      console.log(nodeType, "nodeType");
      const newNode = SequenceNodeFactory.create(nodeType);
      newNode.node_order = order || 1;
      newNode.node_order = createPromises.push(httpManager.post(url, newNode));
    }

    await Promise.all(createPromises);
  }

  async update(nodeId: number, updateNodeDto: any) {
    const url = `${this.getBaseUrl()}/${nodeId}/`;

    console.log(updateNodeDto, 'updateNodeDto');
    if (updateNodeDto.attachments?.length > 0) {
      const formData = new FormData();
      if (updateNodeDto.action)
        formData.append("action", toRaw(updateNodeDto).action);
      if (updateNodeDto.attachments)
        if (updateNodeDto.attachments.length > 0) {
          let attachments_url: string[] = [];
          updateNodeDto.attachments.forEach((file: File | string) => {
            if (file instanceof File)
              formData.append("attachments", toRaw(file));
            else
              attachments_url.push(file);
          });
          formData.append("attachments_public_url", JSON.stringify(attachments_url));
        }
        // else
        //   formData.append("attachments", "");
      // if (updateNodeDto.email_message)
      formData.append("email_message", toRaw(updateNodeDto).email_message);
      if (updateNodeDto.email_identifier)
        formData.append("email_identifier", toRaw(updateNodeDto).email_identifier);
      if (updateNodeDto.email_template)
        formData.append("email_template", toRaw(updateNodeDto).email_template);
      if (updateNodeDto.channel_customer)
        formData.append("channel_customer", toRaw(updateNodeDto).channel_customer);
      if (updateNodeDto.send_as_alias_identifier)
        formData.append("send_as_alias_identifier", toRaw(updateNodeDto).send_as_alias_identifier);
      if (updateNodeDto.email_subject)
        formData.append("email_subject", toRaw(updateNodeDto).email_subject);
      await httpManager.uploadPut(url, formData);
    } else if (updateNodeDto.media && updateNodeDto.media instanceof File) {
      const formData = new FormData();
      if (updateNodeDto.action)
        formData.append("action", toRaw(updateNodeDto).action);
      if (updateNodeDto.queue)
        formData.append("queue", toRaw(updateNodeDto).queue);
      if (updateNodeDto.channel_customer)
        formData.append("channel_customer", toRaw(updateNodeDto).channel_customer);
      if (updateNodeDto.whatsapp_template)
        formData.append("whatsapp_template", toRaw(updateNodeDto).whatsapp_template);
      if (updateNodeDto.media)
        formData.append("media", toRaw(updateNodeDto).media);
      console.log(toRaw(updateNodeDto).parameters, "parameters");
      if (updateNodeDto.parameters?.length > 0)
        formData.append("parameters", JSON.stringify(toRaw(updateNodeDto).parameters));
      await httpManager.uploadPut(url, formData);
    } else {
      if (!(updateNodeDto.media instanceof File)) {
        const mediaUrl = updateNodeDto.media;
        delete updateNodeDto.media;
        updateNodeDto.media_url = mediaUrl;
      }
      console.log(updateNodeDto, "updateNodeDto");
      await httpManager.put(url, updateNodeDto);
    }
  }

  async remove(node: SequenceNode, nodes: SequenceNode[]) {
    // const url = `${this.getBaseUrl()}/${node.id}/`;
    const deletePromises = [];
    const startIndex = nodes.findIndex((n) => n.id === node.id);

    for (let i = startIndex; i < nodes.length; i++) {
      const url = `${this.getBaseUrl()}/${nodes[i].id}/`;

      deletePromises.push(httpManager.delete(url));
    }

    await Promise.all(deletePromises);
  }
}

export const sequenceNodeService = new SequenceNodeService();
